// @flow
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { actions as ModalActions } from '@wh/modal-component';
import { getRecoverLoginUrl } from '@wh/login-component';
import { getActiveLanguageAndCountryCode } from '@wh/language-common';
import LoginWrapper from './login-wrapper';

const mapStateToProps = createStructuredSelector({
    activeLanguageCode: getActiveLanguageAndCountryCode,
    recoverLoginUrl: getRecoverLoginUrl,
});

const mapDispatchToProps = {
    openModal: ModalActions.openModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginWrapper);



// WEBPACK FOOTER //
// ./src/main/login-wrapper/Container.js